/**
 * assets/privada-purchase-widget.js
 * FINAL VERSION: Variant selector works, prices don't update (leave as-is)
 *
 * FIX: addonChecked now derives from whether an add-on card actually
 * exists in the DOM. On the Free Shipping Cigar product the add-on is
 * omitted, so it must start unchecked — otherwise its $8 was being
 * added to the order total (showing $16 instead of $8).
 */

(function () {
  'use strict';

  document.querySelectorAll('.pvd-widget').forEach(initWidget);

  function initWidget(widget) {
    // The add-on card is omitted on the Free Shipping Cigar product
    // (it can't be an add-on to itself). When it's absent, the add-on
    // must start unchecked so its price never lands in the total.
    const hasAddon = !!widget.querySelector('.pvd-addon-card');

    const state = {
      planType:       'sub',
      sellingPlanId:  '',
      variantId:      parseInt(widget.dataset.variantId, 10) || 0,
      basePrice:      0,
      onetimePrice:   0,
      qty:            1,
      addonChecked:   hasAddon,
      addonType:      'sub',
      addonPrice:     parseFloat(widget.dataset.addonPrice || 8),
    };

    const els = {
      planCards:        widget.querySelectorAll('.pvd-plan-card'),
      variantSelect:    widget.querySelector('#pvd-variant-select'),
      addonCard:        widget.querySelector('.pvd-addon-card'),
      addonTypePills:   widget.querySelectorAll('.pvd-addon-type-pill'),
      qtyInput:         widget.querySelector('#pvd-qty-input'),
      summaryPlanLabel: widget.querySelector('#pvd-summary-plan-label'),
      summaryBoxPrice:  widget.querySelector('#pvd-summary-box-price'),
      shippingLine:     widget.querySelector('#pvd-shipping-line'),
      shippingLineLabel:widget.querySelector('#pvd-shipping-line-label'),
      shippingLinePrice:widget.querySelector('#pvd-shipping-line-price'),
      savingsLine:      widget.querySelector('#pvd-savings-line'),
      savingsAmt:       widget.querySelector('#pvd-savings-amt'),
      totalPrice:       widget.querySelector('#pvd-total-price'),
      addonPriceLabel:  widget.querySelector('#pvd-addon-price-label'),
      form:             widget.querySelector('.pvd-product-form'),
      variantInput:     widget.querySelector('#pvd-variant-input'),
      sellingPlanInput: widget.querySelector('#pvd-selling-plan-input'),
      quantityInput:    widget.querySelector('#pvd-quantity-input'),
      ctaBtn:           widget.querySelector('#pvd-atc-btn'),
    };

    const onetimeCard = widget.querySelector('.pvd-plan-card--onetime');
    if (onetimeCard) state.onetimePrice = parseFloat(onetimeCard.dataset.price || 0);

    const initialCard = widget.querySelector('.pvd-plan-card--selected');
    if (initialCard) {
      state.basePrice     = parseFloat(initialCard.dataset.price || 0);
      state.sellingPlanId = initialCard.dataset.sellingPlanId || '';
      state.planType      = initialCard.dataset.planType || 'sub';
      buildFreqPills(initialCard, state);
    }

    if (els.addonCard && state.addonChecked) {
      els.addonCard.classList.add('pvd-addon-card--checked');
      els.addonCard.setAttribute('aria-checked', 'true');
    }
    syncAddonTypeToPlan(state, els);
    updateAddonBenefitText(widget, state.addonType);
    updateSummary(state, els);

    els.planCards.forEach(card => {
      card.addEventListener('click', () => selectPlan(card, widget, state, els));
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPlan(card, widget, state, els);
        }
      });
    });

    /* ── Variant selector: does nothing visually, just updates hidden input ── */
    if (els.variantSelect) {
      els.variantSelect.addEventListener('change', function(e) {
        const selectedVariantId = parseInt(e.target.value, 10);
        state.variantId = selectedVariantId;
        if (els.variantInput) els.variantInput.value = selectedVariantId;
        widget.dataset.variantId = selectedVariantId;
      });
    }

    if (els.addonCard) {
      els.addonCard.addEventListener('click', e => {
        if (e.target.closest('.pvd-addon-type-pill')) return;
        toggleAddon(widget, state, els);
      });
      els.addonCard.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAddon(widget, state, els);
        }
      });
    }

    els.addonTypePills.forEach(pill => {
      pill.addEventListener('click', e => {
        e.stopPropagation();
        selectAddonType(pill.dataset.addonType, widget, state, els);
      });
      pill.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectAddonType(pill.dataset.addonType, widget, state, els);
        }
      });
    });

    if (els.qtyInput) {
      els.qtyInput.addEventListener('input',  () => syncQtyFromInput(state, els));
      els.qtyInput.addEventListener('change', () => syncQtyFromInput(state, els));
    }

    if (els.form) {
      els.form.addEventListener('submit', e => {
        e.preventDefault();
        handleCartAdd(widget, state, els);
      });
    }
  }

  function selectPlan(card, widget, state, els) {
    widget.querySelectorAll('.pvd-plan-card').forEach(c => {
      c.classList.remove('pvd-plan-card--selected');
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('pvd-plan-card--selected');
    card.setAttribute('aria-checked', 'true');

    state.planType      = card.dataset.planType || 'onetime';
    state.sellingPlanId = card.dataset.sellingPlanId || '';
    state.basePrice     = parseFloat(card.dataset.price || 0);

    if (els.sellingPlanInput) {
      els.sellingPlanInput.value = state.sellingPlanId;
    }
    syncRcWidget(widget, state.sellingPlanId);
    buildFreqPills(card, state);
    syncAddonTypeToPlan(state, els);
    updateSummary(state, els);
  }

  function buildFreqPills(card, state) {
    const container = card.querySelector('.pvd-freq-pills');
    if (!container) return;

    const raw = card.dataset.freqOptions;
    if (!raw) {
      wireFreqPills(card, state);
      return;
    }

    let options;
    try { options = JSON.parse(raw); } catch (e) { return; }

    container.innerHTML = '';
    options.forEach((opt, i) => {
      const pill = document.createElement('div');
      pill.className = 'pvd-freq-pill' + (i === 0 ? ' pvd-freq-pill--active' : '');
      pill.textContent = opt.label;
      pill.dataset.planId = opt.plan_id;
      pill.setAttribute('role', 'radio');
      pill.setAttribute('tabindex', '0');
      pill.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
      container.appendChild(pill);
    });

    wireFreqPills(card, state);
  }

  function wireFreqPills(card, state) {
    card.querySelectorAll('.pvd-freq-pill').forEach(pill => {
      pill.addEventListener('click', e => {
        e.stopPropagation();
        card.querySelectorAll('.pvd-freq-pill').forEach(p => {
          p.classList.remove('pvd-freq-pill--active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('pvd-freq-pill--active');
        pill.setAttribute('aria-checked', 'true');

        if (pill.dataset.planId) {
          state.sellingPlanId = pill.dataset.planId;
          const selInput = document.querySelector('#pvd-selling-plan-input');
          if (selInput) selInput.value = state.sellingPlanId;
          syncRcWidget(pill.closest('.pvd-widget'), state.sellingPlanId);
        }
      });
      pill.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pill.click(); }
      });
    });
  }

  function syncRcWidget(widget, planId) {
    if (!planId) return;
    const rcHost = widget.querySelector('recharge-subscription-widget');
    if (!rcHost) return;

    rcHost.dispatchEvent(new CustomEvent('rc:select-plan', {
      detail: { planId },
      bubbles: true,
    }));

    try {
      const shadow = rcHost.shadowRoot;
      if (shadow) {
        const radio = shadow.querySelector(`input[value="${planId}"]`);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } catch (e) {}
  }

  function toggleAddon(widget, state, els) {
    state.addonChecked = !state.addonChecked;
    const card = els.addonCard;
    card.classList.toggle('pvd-addon-card--checked', state.addonChecked);
    card.setAttribute('aria-checked', state.addonChecked ? 'true' : 'false');
    updateSummary(state, els);
  }

  function syncAddonTypeToPlan(state, els) {
    const desiredType = state.planType === 'sub' ? 'sub' : 'onetime';
    if (state.addonType === desiredType) return;

    state.addonType = desiredType;
    els.addonTypePills.forEach(p => {
      const isActive = p.dataset.addonType === desiredType;
      p.classList.toggle('pvd-addon-type-pill--active', isActive);
      p.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
    if (els.addonPriceLabel) {
      els.addonPriceLabel.textContent = desiredType === 'sub'
        ? `$${state.addonPrice}/mo`
        : `$${state.addonPrice}`;
    }
  }

  function selectAddonType(type, widget, state, els) {
    state.addonType = type;
    els.addonTypePills.forEach(p => {
      const isActive = p.dataset.addonType === type;
      p.classList.toggle('pvd-addon-type-pill--active', isActive);
      p.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
    if (els.addonPriceLabel) {
      els.addonPriceLabel.textContent = type === 'sub'
        ? `$${state.addonPrice}/mo`
        : `$${state.addonPrice}`;
    }
    updateAddonBenefitText(widget, type);
    updateSummary(state, els);
  }

  function updateAddonBenefitText(widget, type) {
    const spans = widget.querySelectorAll('.pvd-addon-benefit-text');
    spans.forEach(span => {
      const next = type === 'sub' ? span.dataset.subText : span.dataset.onetimeText;
      if (next && span.textContent !== next) {
        span.textContent = next;
      }
    });
  }

  function syncQtyFromInput(state, els) {
    let raw = parseInt(els.qtyInput.value, 10);
    if (isNaN(raw) || raw < 1) raw = 1;
    if (raw > 99) raw = 99;
    state.qty = raw;
    if (String(raw) !== els.qtyInput.value) els.qtyInput.value = raw;
    if (els.quantityInput) els.quantityInput.value = state.qty;
    updateSummary(state, els);
  }

  function updateSummary(state, els) {
    const boxTotal   = state.basePrice * state.qty;
    const addonTotal = state.addonChecked ? state.addonPrice : 0;
    const grand      = boxTotal + addonTotal;

    const fmt = v => `$${v.toFixed(2)}`;

    if (els.summaryPlanLabel) {
      const planName = getPlanName(state);
      els.summaryPlanLabel.textContent = `${planName} × ${state.qty}`;
    }
    if (els.summaryBoxPrice) els.summaryBoxPrice.textContent = fmt(boxTotal);
    if (els.totalPrice)      els.totalPrice.textContent      = fmt(grand);

    if (els.shippingLine) {
      els.shippingLine.style.display = state.addonChecked ? 'flex' : 'none';
      if (els.shippingLineLabel && state.addonChecked) {
        els.shippingLineLabel.textContent = state.addonType === 'sub'
          ? 'Free Shipping Cigar (subscribe)'
          : 'Free Shipping Cigar (one-time)';
      }
      if (els.shippingLinePrice) {
        els.shippingLinePrice.textContent = fmt(state.addonPrice);
      }
    }

    if (els.savingsLine) {
      if (state.planType === 'sub' && state.onetimePrice > state.basePrice) {
        const saved = (state.onetimePrice - state.basePrice) * state.qty;
        els.savingsLine.style.display   = 'flex';
        if (els.savingsAmt) els.savingsAmt.textContent = fmt(saved);
      } else {
        els.savingsLine.style.display = 'none';
      }
    }
  }

  function getPlanName(state) {
    const selectedCard = document.querySelector('.pvd-plan-card--selected');
    if (selectedCard) {
      const nameEl = selectedCard.querySelector('.pvd-plan-name');
      if (nameEl) return nameEl.textContent.trim();
    }
    return state.planType === 'sub' ? 'Subscription' : 'One-Time Purchase';
  }

  function addToCartXhr(items) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept',       'application/json');
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText)); }
          catch (e) { resolve({}); }
        } else {
          let msg = 'Cart add failed';
          try {
            const body = JSON.parse(xhr.responseText);
            msg = body.description || body.message || msg;
          } catch (e) {}
          reject(new Error(msg));
        }
      };
      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(JSON.stringify({ items }));
    });
  }

  async function handleCartAdd(widget, state, els) {
    const btn = els.ctaBtn;
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }

    const items = [];

    /* Read variant ID directly from dropdown */
    const variantId = els.variantSelect
      ? parseInt(els.variantSelect.value, 10)
      : parseInt(widget.dataset.variantId, 10);

    const mainItem = {
      id:       variantId,
      quantity: state.qty,
    };
    if (state.planType === 'sub' && state.sellingPlanId) {
      mainItem.selling_plan = parseInt(state.sellingPlanId, 10);
    }
    items.push(mainItem);

    // Only attach the add-on when it actually exists and is checked.
    if (state.addonChecked && els.addonCard) {
      const addonCard = els.addonCard;
      const addonVariantId = state.addonType === 'sub'
        ? addonCard?.dataset.addonVariantSub
        : addonCard?.dataset.addonVariantOnetime;

      if (addonVariantId) {
        const addonItem = {
          id:       parseInt(addonVariantId, 10),
          quantity: 1,
        };
        if (state.addonType === 'sub' && addonCard?.dataset.addonSellingPlanId) {
          addonItem.selling_plan = parseInt(addonCard.dataset.addonSellingPlanId, 10);
        }
        items.push(addonItem);
      }
    }

    try {
      await addToCartXhr(items);

      if (btn) {
        btn.classList.add('pvd-cta-btn--success');
        setTimeout(() => {
          btn.classList.remove('pvd-cta-btn--success');
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }, 2200);
      }

      if (window.RechargePubSub && typeof window.RechargePubSub.publish === 'function') {
        try {
          window.RechargePubSub.publish('cart:added', { items });
          window.RechargePubSub.publish('cart:updated', { items });
        } catch (e) {}
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      showViewCartLink(widget);

    } catch (error) {
      console.error('[Privada widget] Cart add error:', error);
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
      alert(error.message || 'Something went wrong. Please try again.');
    }
  }

  function showViewCartLink(widget) {
    let link = widget.querySelector('.pvd-view-cart-link');
    if (!link) {
      const form = widget.querySelector('.pvd-product-form');
      if (!form) return;
      link = document.createElement('a');
      link.className = 'pvd-view-cart-link';
      link.href = '/cart';
      link.textContent = 'View cart →';
      link.setAttribute('style', [
        'display:block',
        'text-align:center',
        'margin-top:10px',
        'font-size:13px',
        'font-weight:500',
        'color:#C74740',
        'text-decoration:underline',
        'text-underline-offset:3px',
      ].map(s => s + ' !important').join(';'));
      form.insertAdjacentElement('afterend', link);
    }
    link.style.setProperty('display', 'block', 'important');
  }

})();